export default function isPreview(): boolean {
  if (globalThis?.location?.search) {
    const params = new URLSearchParams(globalThis.location.search);
    return params.has('preview');
  }

  return false;
}
